export const EventStatusCode = Object.freeze({
    NOT_STARTED: -2,
    IN_PROGRESS: -1,
    FINAL: 0
});

export const getByCode = (code) => {
    return Object.keys(EventStatusCode).find(
        (key) => EventStatusCode[key] === code
    );
};

const EventStatus = () => {
    const isInProgress = (event) => {
        return event.statusCode === EventStatusCode.IN_PROGRESS;
    };

    const isFinal = (event) => {
        return event.statusCode > EventStatusCode.IN_PROGRESS;
    };

    const isStarted = (event) => {
        return event.statusCode >= EventStatusCode.IN_PROGRESS;
    };

    const resolve = (event) => {
        let friendly = "";

        if (isInProgress(event)) {
            friendly = "In Progress";
        } else if (isFinal(event)) {
            friendly = "Final";
        } else if (!isStarted(event)) {
            friendly = "Not Started";
        }

        return friendly;
    };

    return {
        isInProgress,
        isFinal,
        isStarted,
        resolve
    };
};

export default EventStatus();
